'use client';
import { createContext, type PropsWithChildren, useContext, useState } from 'react';
import { defaultHeaderOptions } from './constants';
import type { SatelliteHeaderOptions } from './types';

type SatelliteContextValue = {
  headerOptions: Partial<SatelliteHeaderOptions>;
  segmentPageViewListenerAdded: boolean;
  setSegmentPageViewListenerAdded: (val: boolean) => void;
};

const SatelliteContext = createContext<SatelliteContextValue | null>(null);

export type SatelliteProviderProps = {
  headerOptions?: Partial<SatelliteHeaderOptions>;
};

export const SatelliteProvider = ({
  headerOptions,
  children,
}: PropsWithChildren<SatelliteProviderProps>) => {
  const [segmentPageViewListenerAdded, setSegmentPageViewListenerAdded] = useState(false);

  return (
    <SatelliteContext.Provider
      value={{
        headerOptions: { ...defaultHeaderOptions, ...headerOptions },
        segmentPageViewListenerAdded,
        setSegmentPageViewListenerAdded,
      }}
    >
      {children}
    </SatelliteContext.Provider>
  );
};

export const useSatelliteContext = () => {
  const context = useContext(SatelliteContext);

  if (!context) {
    throw new Error('useSatelliteContext must be used within SatelliteProvider');
  }

  return context;
};
